import React from "react";


const SkillCard = ({icon, title, loader, number}) => {
    return (
        <div className="flex flex-col max-w-lg m-10">
            <div className="flex flex-row">
               {icon}
                <div className="flex flex-col ml-3">
                    <p className="text-secondary font-bold">{title}</p>
                    <span className="text-light">Used in {number} projects</span>
                </div>
            </div>
            <div className="w-full bg-blue20 rounded-full h-2.5 dark:bg-blue20 mt-2">
                <div className="bg-secondary h-2.5 rounded-full" style={{width : `${loader}%`}}></div>
            </div>
        </div>
    )
}

export default SkillCard;